import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestLiteModel } from 'api-hooks/guest';
import { HotelLiteModel, HotelRoomModel } from 'api-hooks/hotel';
import { Expose, Type } from 'class-transformer';
import { HotelCheckInStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { PurchaseModel } from '../common/model';

// Model

export class HotelPurchasePurchaseGuestItemModel {
  id: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Expose({ name: 'is_lead' })
  isLead: boolean;
}

export class HotelPurchasePurchaseHotelItemModel {
  id: string;
  detail?: string | null; // Other word: Meals

  @Expose({ name: 'check_in_status' })
  checkInStatus: HotelCheckInStatusEnum;

  @Expose({ name: 'hotel_room' })
  @Type(() => HotelRoomModel)
  hotelRoom: HotelRoomModel;

  @Type(() => Date)
  date: Date;

  @Type(() => Number)
  night: number;

  @Type(() => Number)
  room: number;

  @Type(() => Number)
  price: number;

  @Type(() => Number)
  pax?: number | null;

  @Expose({ name: 'check_in' })
  @Type(() => Date)
  checkIn: Date;

  @Expose({ name: 'check_out' })
  @Type(() => Date)
  checkOut: Date;
}

export class HotelPurchasePurchaseAddOnsItemModel {
  id: string;
  description: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Type(() => Number)
  unit?: number;

  @Expose({ name: 'price_unit' })
  @Type(() => Number)
  priceUnit?: number;
}

export class HotelPurchasePaymentChannelModel extends CommonModel {
  name: string;
  description?: string;

  @Expose({ name: 'is_active' })
  @Type(() => Boolean)
  isActive: boolean;
}

export class HotelPurchaseItemModel {
  id: string;
  remark?: string; // deprecated

  @Type(() => HotelLiteModel)
  hotel: HotelLiteModel;

  @Expose({ name: 'booking_code' })
  bookingCode?: string | null;

  @Expose({ name: 'is_city_tax' })
  @Type(() => Boolean)
  isCityTax: boolean;

  @Expose({ name: 'is_by_pax' })
  @Type(() => Boolean)
  isByPax: boolean;

  @Expose({ name: 'city_tax' })
  cityTax: string | null;

  @Expose({ name: 'hotel_purchase_guests' })
  @Type(() => HotelPurchasePurchaseGuestItemModel)
  hotelPurchaseGuests: HotelPurchasePurchaseGuestItemModel[];

  @Expose({ name: 'hotel_purchase_hotels' })
  @Type(() => HotelPurchasePurchaseHotelItemModel)
  hotelPurchaseHotels: HotelPurchasePurchaseHotelItemModel[];

  @Expose({ name: 'hotel_purchase_add_ons' })
  @Type(() => HotelPurchasePurchaseAddOnsItemModel)
  hotelPurchaseAddOns: HotelPurchasePurchaseAddOnsItemModel[];

  @Expose({ name: 'hotel_confirmation' })
  hotelConfirmation: any;
}

export class HotelPurchaseLiteModel extends CommonModel {
  code: string;
  description: string;
  type: string;
  agent: string;
  number: string;
  status: string;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'payment_channel' })
  paymentChannel: string;

  @Type(() => Number)
  total: number;
}

export class HotelPurchaseModel extends PurchaseModel {
  @Expose({ name: 'hotel_purchases' })
  @Type(() => HotelPurchaseItemModel)
  hotelPurchases: HotelPurchaseItemModel[];
}

// export class HotelPurchaseAddOnsDetailModel{
//   description:string
// }

// // export class HotelPurchaseDetailModel{
// //   @Expose({name:'city_tax'})
// //   cityTax:string

// //   @Type(()=>HotelLiteModel)
// //   hotel:HotelLiteModel

// //   @Expose({name:'hotel_confirmation'})
// //   hotelConfirmation:any

// //   id:string

// //   @Expose({name:'is_city_tax'})
// //   @Type(()=>Boolean)
// //   isCityTax:boolean

// //   remark:string

// //   @Expose({name:'hotel_purchase_add_ons'})
// // }

// Input

export type getHotelPurchasesInput = {
  params: CommonParamInput;
};

export type getHotelPurchaseInput = {
  id: string;
};

export type HotelPurchasePurchaseGuestItemInput = {
  id?: string;
  guestId: string;
  isLead: boolean;
};

export type HotelPurchasePurchaseHotelItemInput = {
  id?: string;
  checkIn: Date | null;
  checkOut: Date | null;
  hotelRoomId: string | null;
  price: number;
  night: number;
  room: number;
  pax?: number | null;
  detail?: string | null;
};

export type HotelPurchasePurchaseAddOnsItemInput = {
  id?: string;
  guestId: string | null;
  description: string;
  price: number;
  priceUnit?: number;
  unit?: number;
};

export type HotelPurchasePurchaseItemInput = {
  id?: string;
  hotelId?: string | null;
  bookingCode?: string | null;
  remark?: string;
  isCityTax: boolean;
  cityTax: string;
  hotelPurchaseGuests: HotelPurchasePurchaseGuestItemInput[];
  hotelPurchaseHotels: HotelPurchasePurchaseHotelItemInput[];
  hotelPurchaseAddOns: HotelPurchasePurchaseAddOnsItemInput[];
};

export type HotelPurchaseMutationInput = {
  //Required - Detail
  code: string;
  description: string;
  type: string;
  transactionAt: Date | null;
  tourRefId?: string | null;
  invoiceRefId?: string | null;
  agentId: string | null;
  paymentChannelId: string | null;
  hotelPurchases: HotelPurchasePurchaseItemInput[];
  discount: number;
  otherCost: number;
  total: number;
  needApproval: boolean;

  // Not Required
  refId?: string | null;
  orderNumber?: string | null;
  parentRefId?: string | null;
};

export type HotelPurchaseUpdateInput = {
  hotelPurchaseId: string;
  body: HotelPurchaseMutationInput;
};

export type HotelPurchaseDeleteInput = {
  hotelPurchaseId: string;
};
